<template>
  <div class="nav-box">
    <div class="left-item">
      <div @click="backHome" :class="{ 'back-show': !backFlag }">
        <Icon type="ios-arrow-back" class="back-span" />
        <span class="back-span back-margin">{{ $t("common.back") }}</span>
      </div>
      <span>{{ routerName }}</span>
    </div>
    <div v-if="languageFlag" class="right-item">
      <Dropdown trigger="click" @on-click="changeLanguage">
        <Button type="default" ghost>
          {{ languageName }}
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem
            v-for="item in LanguageList"
            :key="item.type"
            :name="item.type"
          >
            {{ item.name }}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div v-if="versionFlag" class="right-item">
      <Button type="primary">{{ version }}</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "homeNav",
  components: {},
  data() {
    return {
      LanguageList: this.global.LanguageList,
      languageName: "",
      version: "V1.10.5-20250428", // 打包前修改
    };
  },
  props: {
    routerName: {
      type: String,
    },
    backFlag: {
      type: Boolean,
      default: false,
    },
    versionFlag: {
      type: Boolean,
      default: false,
    },
    languageFlag: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  mounted() {
    // 从pc端携带的语言标识
    if (this.$route.query.lang) {
      localStorage.setItem("language", this.$route.query.lang);
    }
    // 判断语言
    let res = this.$common.setLanguageValue();
    this.languageName = res.name;
  },
  methods: {
    changeLanguage(type) {
      let res = this.$common.handleLanguage(type);
      this.languageName = res.name;
    },
    backHome() {
      this.$router.push("/");
      this.$emit("clearCase"); // 地址簿配置模块需要清除vuex
    },
  },
};
</script>
